@if (hasActiveEmployeeConnection$ | async) {
    <adapt-dashboard-element name="Cultural leadership">
        <ng-container *adaptLoadingUntilFirstEmit="let culturalRelationship of culturalRelationship$">
            @if (culturalRelationship) {
                {{ culturalLeaderName$ | async }}:
                <adapt-link-person [person]="culturalRelationship.culturalLeader"></adapt-link-person>
            } @else if (hasCulturalExclusion$ | async) {
                This person has been excluded from the Cultural Leadership Framework
            } @else {
                No {{ (culturalLeaderName$ | async)?.toLowerCase() }} has been set
            }
        </ng-container>
    </adapt-dashboard-element>
}
